import { render } from "./ManagePartnerDocuments.vue?vue&type=template&id=53011a6d&scoped=true"
import script from "./ManagePartnerDocuments.vue?vue&type=script&lang=js"
export * from "./ManagePartnerDocuments.vue?vue&type=script&lang=js"

import "./ManagePartnerDocuments.vue?vue&type=style&index=0&id=53011a6d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53011a6d"]])

export default __exports__